/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Policy_Retention_Account_DescInputs */

const es_privacy_policy_retention_account_desc = /** @type {(inputs: Privacy_Policy_Retention_Account_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retenida mientras su cuenta permanece activa. Al eliminar cuenta, credenciales se revocan inmediatamente y metadatos se eliminan en 30 dias.`)
};

const en_privacy_policy_retention_account_desc = /** @type {(inputs: Privacy_Policy_Retention_Account_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retained while your account remains active. Upon account deletion, credentials are immediately revoked and metadata deleted within 30 days.`)
};

/**
* | output |
* | --- |
* | "Retained while your account remains active. Upon account deletion, credentials are immediately revoked and metadata deleted within 30 days." |
*
* @param {Privacy_Policy_Retention_Account_DescInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const privacy_policy_retention_account_desc = /** @type {((inputs?: Privacy_Policy_Retention_Account_DescInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Policy_Retention_Account_DescInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_privacy_policy_retention_account_desc(inputs)
	return en_privacy_policy_retention_account_desc(inputs)
});
export { privacy_policy_retention_account_desc as "privacy_policy.retention.account_desc" }